import {Project} from "../models/project";


export class ProjectTypeFilter {

    /**
     * Apply type filters
     * @param projects
     * @param filters
     */
    static apply(projects: Project[], filters: string[]): Project[] {
        if (!filters || filters.length === 0) {
            return projects;
        }
        // check if type filters included
        if (!filters.some((f) => f.includes("type-"))) {
            // no type filters
            return projects;
        }

        return projects.filter((p: Project) => {
            const key = `type-${p.typeId}`;
            // show project when filter key matches
            return filters.includes(key);
        });
    }
}
